import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Facebook, Instagram, Youtube, Calendar, Linkedin } from 'lucide-react';
import { clinicInfo, menuItems } from '../data/servicesData';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_0256d13d-9170-4042-be2c-1474dbb0098c/artifacts/n8e0gl89_dr%20thamrai%20gold%20logo.png" 
              alt="Dr. Thamarai's Dental Care"
              className="footer-logo"
            />
            <p className="footer-description">
              Providing exceptional dental care in East Tambaram, Chennai. Advanced treatments with a gentle touch.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/drthamaraisdentalcare" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/dr.thamaraisdentalcare/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://www.youtube.com/@Dr.ThamaraisDentalCare" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube">
                <Youtube size={20} />
              </a>
              <a href="https://www.linkedin.com/company/drthamaraisdentalcare/" target="_blank" rel="noopener noreferrer" className="social-icon linkedin-icon" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="https://calendar.app.google/HUErwbd6Tq1Btq9Y8" target="_blank" rel="noopener noreferrer" className="social-icon appointment-icon" aria-label="Book Appointment">
                <Calendar size={20} />
              </a>
              <a href="https://maps.app.goo.gl/cZQY5LEVwTz3yHb4n" target="_blank" rel="noopener noreferrer" className="social-icon location-icon" aria-label="Get Directions">
                <MapPin size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/dental-checkup-chennai">Dental Checkup</Link></li>
              <li><Link to="/clear-aligners-east-tambaram">Clear Aligners</Link></li>
              <li><Link to="/dental-implants-chennai">Dental Implants</Link></li>
              <li><Link to="/root-canal-treatment-chennai">Root Canal</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><Link to="/teeth-cleaning-tambaram">Teeth Cleaning</Link></li>
              <li><Link to="/invisible-braces-chennai">Invisible Braces</Link></li>
              <li><Link to="/braces-treatment-chennai">Braces Treatment</Link></li>
              <li><Link to="/gum-treatment-east-tambaram">Gum Treatment</Link></li>
              <li><Link to="/root-canal-treatment-chennai">Root Canal</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact Us</h4>
            <div className="contact-info">
              <div className="contact-item">
                <MapPin size={18} className="contact-icon" />
                <a 
                  href="https://www.google.com/maps/dir/?api=1&destination=Dr+Thamarai+Dental+Care+Tambaram+Chennai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {clinicInfo.address}
                </a>
              </div>
              <div className="contact-item">
                <Phone size={18} className="contact-icon" />
                <a href={`tel:${clinicInfo.phone}`}>{clinicInfo.phone}</a>
              </div>
              <div className="contact-item">
                <Clock size={18} className="contact-icon" />
                <div>
                  <div>10 am–1:30 pm, 5–9 pm</div>
                  <div>Sunday Holiday</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2014 {clinicInfo.name}. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-conditions">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
